
import { defineComponent } from 'vue';
import { LoadingOutlined } from '@ant-design/icons-vue';
import {
  Row, Col, Input, Checkbox,
  Spin,
} from 'ant-design-vue';

const { Password } = Input;
export default defineComponent({
  name: 'Login',
  components: {
    Row,
    Col,
    Input,
    Checkbox,
    Password,
    Spin,
    LoadingOutlined,
  },
  data() {
    return {
      email: '',
      password: '',
      rememberMe: false,
      showPassword: false,
    };
  },
  computed: {
    resetPasswordLocation() {
      return {
        path: '/reset-password',
        query: { ...this.$route.query },
      };
    },
  },
  props: {
    sign: {
      type: Function,
    },
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    onCheckChange() {
      this.rememberMe = !this.rememberMe;
    },
  },
});
